import { render, staticRenderFns } from "./ZoneForm.vue?vue&type=template&id=3593da0d"
import script from "./ZoneForm.vue?vue&type=script&lang=js"
export * from "./ZoneForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports